import { useEffect } from "react";

export const useScrollTopOnMount = () => {
  useEffect(() => {
    const content = document.getElementById("content");
    if (content && !document.body.classList.contains("is-member")) {
      setTimeout(() => {
        window.scrollTo(0, content.offsetTop);
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, []);
};
